<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Spettacoli', route: '/backoffice/spettacoli/' }, { label: 'Utenti area compagnia', active: true }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">Utenti area compagnia</h1>
</section>

<section class="px-container pb-16">
    <div class="ac-section-head">
        <div>
            <h2>Utenti</h2>
            <span class="ac-meta">{{ spettacolo?.spettacolo || 'accesso area compagnia' }}</span>
        </div>
    </div>

    <p-table #table
        [loading]="loading"
        [value]="utenti"
        responsiveLayout="stack"
        [breakpoint]="'960px'"
        styleClass="scheda-tabella p-datatable-sm"
        [paginator]="true"
        [showCurrentPageReport]="true"
        [rowHover]="true"
        [globalFilterFields]="['username','email', 'spettacolo']"
        currentPageReportTemplate="{first} di {last} su {totalRecords} utenti"
        [rows]="10"
        [rowsPerPageOptions]="[5, 10, 20, 50]">
        <ng-template pTemplate="caption">
            <div class="flex lg:flex-row flex-col gap-3 w-full">
                <div class="lg:w-3/4 w-full">
                    <p-iconfield iconPosition="left" [style]="{'width': '100%'}">
                        <p-inputicon styleClass="bi bi-search" />
                        <input type="text" pInputText (input)="onGlobalFilter(table, $event)" placeholder="Cerca utente…" [style]="{'width': '100%'}" />
                    </p-iconfield>
                </div>
                <div class="lg:w-1/4 w-full table-toolbar-btns">
                    <button class="flex-1 acc-btn" type="button" (click)="add = true">
                        <i class="bi bi-plus"></i>
                        Aggiungi utente
                    </button>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="email">Email <span class="inline-flex"><p-sortIcon field="email" /></span></th>
                <th pSortableColumn="username">Username <span class="inline-flex"><p-sortIcon field="username" /></span></th>
                <th class="text-center">Azioni</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-utente>
            <tr>
                <td>
                    <span class="p-column-title">Email</span>
                    <span class="cell-nome">{{utente.email || '-'}}</span>
                </td>
                <td>
                    <span class="p-column-title">Username</span>
                    {{utente.username || '-'}}
                </td>
                <td class="text-center">
                    <div class="table-actions">
                        <i class="bi bi-pencil" (click)="onOpenEdit(utente)"></i>
                        <p-divider layout="vertical"></p-divider>
                        <p-confirmPopup #delete>
                            <ng-template pTemplate="headless" let-message>
                                <div class="border-round p-3">
                                    <span class="text-base">{{ message.message }}</span>
                                    <div class="flex align-items-center gap-2 mt-3">
                                        <button type="button" class="acc-btn flex-1" (click)="onDelete()">Elimina</button>
                                        <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onClose()">Annulla</button>
                                    </div>
                                </div>
                            </ng-template>
                        </p-confirmPopup>
                        <i class="bi bi-trash" (click)="onOpenDelete($event, utente)"></i>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="3">Nessun utente trovato.</td>
            </tr>
        </ng-template>
    </p-table>
</section>

<p-dialog [visible]="(add || edit)" [style]="{width: '50%'}" [header]="add ? 'Aggiungi utente' : 'Modifica utente'" [focusOnShow]="false" [modal]="true" styleClass="accrediti-dialog" (visibleChange)="onCloseModal()">
    <ng-template pTemplate="content">
        @if (add) {
            <p class="text-sm mb-2" style="color: var(--acc-ink-mute)">Se l'utente non è ancora presente, verrà inviata un'email con le credenziali d'accesso e l'informativa sul portale accreditamenti compagnie.</p>
        }

        <form [formGroup]="formUtente" class="accrediti-form flex flex-col gap-6" (ngSubmit)="add ? onAdd() : onEdit()">
            <div class="flex lg:flex-row flex-col gap-4">
                <div class="fld flex-1">
                    <label>Username</label>
                    <input type="text" pInputText class="w-full" placeholder="Username" formControlName="username" name="username" id="username" />
                </div>
                <div class="fld flex-1">
                    <label>* Email</label>
                    <input type="text" pInputText class="w-full" placeholder="Email" formControlName="email" />
                    @if (formUtente.get('email')?.hasError('required') && (formUtente.get('email')?.dirty || formUtente.get('email')?.touched)) {
                        <small class="text-red-600 block mt-2 font-medium">L'email è obbligatoria.</small>
                    }
                    @if (formUtente.get('email')?.hasError('email') && (formUtente.get('email')?.dirty || formUtente.get('email')?.touched)) {
                        <small class="text-red-600 block mt-2 font-medium">Inserire un'email valida.</small>
                    }
                </div>
            </div>

            <div class="flex lg:flex-row flex-col gap-4">
                <div class="fld flex-1">
                    <label>{{add ? '* ' : ''}}Password</label>
                    <p-password [toggleMask]="true" [feedback]="true" formControlName="password" placeholder="Password" styleClass="w-full" inputStyleClass="w-full" autocomplete />
                    @if (formUtente.get('password')?.hasError('required') && (formUtente.get('password')?.dirty || formUtente.get('password')?.touched)) {
                        <small class="text-red-600 block mt-2 font-medium">La password è obbligatoria.</small>
                    }
                    @if (formUtente.get('password')?.hasError('minlength') && (formUtente.get('password')?.dirty || formUtente.get('password')?.touched)) {
                        <small class="text-red-600 block mt-2 font-medium">Inserire almeno 4 caratteri.</small>
                    }
                    @if (formUtente.hasError('mismatch') && (formUtente.get('password')?.dirty || formUtente.get('password')?.touched) && (formUtente.get('confirm_password')?.dirty || formUtente.get('confirm_password')?.touched)) {
                        <small class="text-red-600 block mt-2 font-medium">Le due password non combaciano.</small>
                    }
                </div>
                <div class="fld flex-1">
                    <label>{{add ? '* ' : ''}}Conferma password</label>
                    <p-password [toggleMask]="true" [feedback]="true" formControlName="confirm_password" placeholder="Conferma Password" styleClass="w-full" inputStyleClass="w-full" autocomplete />
                    @if (formUtente.get('confirm_password')?.hasError('required') && (formUtente.get('confirm_password')?.dirty || formUtente.get('confirm_password')?.touched)) {
                        <small class="text-red-600 block mt-2 font-medium">La password è obbligatoria.</small>
                    }
                    @if (formUtente.get('confirm_password')?.hasError('minlength') && (formUtente.get('confirm_password')?.dirty || formUtente.get('confirm_password')?.touched)) {
                        <small class="text-red-600 block mt-2 font-medium">Inserire almeno 4 caratteri.</small>
                    }
                    @if (formUtente.hasError('mismatch') && (formUtente.get('password')?.dirty || formUtente.get('password')?.touched) && (formUtente.get('confirm_password')?.dirty || formUtente.get('confirm_password')?.touched)) {
                        <small class="text-red-600 block mt-2 font-medium">Le due password non combaciano.</small>
                    }
                </div>
            </div>

            <div class="acc-actions">
                <button type="button" class="acc-btn acc-btn-ghost" (click)="onCloseModal()">Annulla</button>
                <button class="acc-btn acc-btn-primary" type="submit" [disabled]="!formUtente.valid">{{add ? 'Aggiungi' : 'Modifica'}}</button>
            </div>
        </form>
    </ng-template>
</p-dialog>
